module.exports = __webpack_public_path__ + "img/shot_tx19120601.1e6118dc.jpg";